import React from 'react'
import PropTypes from 'prop-types'
import { ParagraphStyled } from './styles'

const DescriptionProject = ({text}) => {
  return (
    <ParagraphStyled
      data-testid='element-paragraph'
    >
      {text}
    </ParagraphStyled>
  )
}

DescriptionProject.propTypes = {
  text:PropTypes.string.isRequired,
}

export default DescriptionProject
